/**
 * @name Partition
 * @desc Creates an array of elements split into two groups. Elements that
 * return truthy from running through predicate will be on the first group and
 * the rest on the second.
 * The predicate is invoked with one argument: (value).
 *
 * @example
 * // const data = [1, 2, 3, 4, 5]
 * // const result = partition(data, item => item > 3)
 * // -> [[4, 5], [1, 2, 3]]
 */
export default <T>(elements: T[], predicate: (item: T) => boolean): [T[], T[]] => {
  return elements.reduce(
    (result: [T[], T[]], element) => {
      result[predicate(element) ? 0 : 1].push(element)
      return result
    },
    [[], []]
  )
}
